/*
计算账期
 */
import calAccountPeriod from './calAccountPeriod.js'

const __toString = Object.prototype.toString

// 是否是数组
export function isArray(obj) {
  return __toString.call(obj) === '[object Array]'
}

// 是否是对象
export function isObject(obj) {
  return __toString.call(obj) === '[object Object]'
}

// 手机号正则
export const phoneNoReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/

/**
 * extendOwn
 * 只复制目标对象已有的属性（浅复制）
 */
export function extendOwn(destination, ...sources) {
  const res = {}
  let sourcesArr = []
  if (isObject(destination)) {
    if (isArray(sources)) {
      sourcesArr = sources
    } else {
      sourcesArr.push(sources)
    }
    Object.keys(destination).forEach(key => {
      sourcesArr.forEach(src => {
        if (!isObject(src)) return
        // eslint-disable-next-line no-prototype-builtins
        res[key] = src.hasOwnProperty(key) ? src[key] : destination[key]
      })
    })
  }
  return res
}

/**
 * 删除对象空值
 */
export function removeEmpty(obj) {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key])
    else if (obj[key] === null || obj[key] === '' || obj[key] === undefined) delete obj[key]
  })
  return obj
}

/**
 * 判断环境
 */
export function isProd() {
  return ['bike.meituan.com'].indexOf(window.location.hostname) > -1
}

/**
 * 判断环境
 */
export function isStage() {
  const hostname = window.location.hostname
  return hostname === 'alpha-m3.mobike.com' || hostname.indexOf('.st.sankuai.com') > -1
}

// 数字千位符格式化
export function toThousands(num) {
  const numStr = (num || 0).toString()

  return numStr.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}

/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * eg:
 * (new Date()).pattern("yyyy-MM-dd hh:mm:ss.S") ==> 2007-07-02 08:09:04.423
 * (new Date()).pattern("yyyy-MM-dd E HH:mm:ss") ==> 2007-03-10 二 20:09:04
 * (new Date()).pattern("yyyy-MM-dd EE hh:mm:ss") ==> 2007-03-10 周二 08:09:04
 * (new Date()).pattern("yyyy-MM-dd EEE hh:mm:ss") ==> 2007-03-10 星期二 08:09:04
 * (new Date()).pattern("yyyy-M-d h:m:s.S") ==> 2007-7-2 8:9:4.18
 */
export function dateFormat(time, fmt = 'yyyy-MM-dd') {
  if (!time) {
    return ''
  } else if (time.length === 13) {
    // 时间戳
    time = +time
  }
  const date = new Date(time)
  const o = {
    'M+': date.getMonth() + 1,
    // 月份
    'd+': date.getDate(),
    // 日
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    // 小时
    'H+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    S: date.getMilliseconds(), // 毫秒
  }
  const week = {
    0: '\u65e5',
    1: '\u4e00',
    2: '\u4e8c',
    3: '\u4e09',
    4: '\u56db',
    5: '\u4e94',
    6: '\u516d',
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') +
        week[date.getDay() + '']
    )
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

/**
 * 判断是否为 number
 */
export function isNumber(obj) {
  return typeof obj === 'number' && !isNaN(obj)
}

/**
 * 判断对象属性是否存在
 */
export function isUndef(val) {
  return val === undefined || val === null
}

/**
 * 小数加法计算, 解决精度问题
 */
export function computeAdd(arg1, arg2) {
  if (isUndef(arg1) || isUndef(arg2)) return 0

  const processedArg1 = arg1.toString()
  const processedArg2 = arg2.toString()

  const powerArg1 = processedArg1.indexOf('.') > -1 ? processedArg1.split('.')[1].length : 0
  const powerArg2 = processedArg2.indexOf('.') > -1 ? processedArg2.split('.')[1].length : 0

  let enlargeArg1
  let enlargeArg2
  const enlargeValue = Math.pow(10, Math.max(powerArg1, powerArg2))

  if (powerArg1 > powerArg2) {
    enlargeArg1 = Number(processedArg1.replace('.', ''))
    enlargeArg2 = Number(processedArg2.replace('.', '')) * Math.pow(10, powerArg1 - powerArg2)
  } else if (powerArg1 < powerArg2) {
    enlargeArg1 = Number(processedArg1.replace('.', '')) * Math.pow(10, powerArg2 - powerArg1)
    enlargeArg2 = Number(processedArg2.replace('.', ''))
  } else {
    enlargeArg1 = Number(processedArg1.replace('.', ''))
    enlargeArg2 = Number(processedArg2.replace('.', ''))
  }

  return (enlargeArg1 + enlargeArg2) / enlargeValue
}

export function downloadFile(url) {
  const elemIF = document.createElement('iframe')
  elemIF.src = url
  elemIF.style.display = 'none'
  document.body.appendChild(elemIF)
}

export { calAccountPeriod }

/**
 * 发送自定义指标数据
 * @param {*} data： String 或者 obj
 * obj 可选属性包括：name value tags
 * name: 表示指标名称，要求类型为 string；
 * value: 表示指标值，要求类型为 number;
 * tags: 为参数对象，对象属性名表示标签名称，对应的属性值表示标签值。
 */
export function sendMetricLog(data = {}) {
  // 获取 MetricManager 实例
  const metricInst = window.owl('newMetricInst')
  if (metricInst) {
    if (Object.prototype.toString.call(data) === '[object String]') {
      // 设置自定义指标数据
      metricInst.setMetric(data, 1)
    } else if (data.key) {
      metricInst.setMetric(data.key, data.value || 1)
      // 增加维度信息
      if (data.tags && JSON.stringify(data.tags) !== '{}') {
        metricInst.setTags(data.tags)
      }
    }
  }
}

// 判断字符串是否为数字
export function isNumberType(val) {
  var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true
  }
  return false
}

// 千分化
export function numThousand(num) {
  if (!isNumberType(num)) return num
  if (+num === 0) return 0
  const newNum = (+num)
    .toFixed(2)
    .toString()
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  return newNum.toString().replace(/\.00/, '')
}

/**
 * 灵犀PV埋点
 * @param {String} cid 页面cid
 * @param {Object} custom PV自定义参数
 */
export function pushLxAnalyticsPV(cid, params = {}) {
  if (!cid) return
  const custom = {
    daxiang_mis_number: window.__BIKE_POLARIS__.mis,
    ...params,
  }
  console.info('pushLxAnalyticsPV', 'cid', cid, 'custom', custom)
  window.LXAnalytics &&
    window.LXAnalytics(
      'pageView',
      {
        custom,
      },
      null,
      cid
    )
}

/**
 * 灵犀MC埋点
 * @param {String} bid ModuleClick
 * @param {String} cid PageView
 * @param {String} misId
 */
export function pushLXModuleClick(bid, cid, misId, extraParams = {}) {
  console.log('pushLXModuleClick', bid, cid, misId, extraParams)
  if (!bid || !cid || !misId) return
  window.LXAnalytics &&
    window.LXAnalytics(
      'moduleClick',
      bid,
      {
        custom: Object.assign({ daxiang_mis_number: misId }, extraParams),
      },
      { cid: cid }
    )
}

/**
 * @description 获取间隔内有效天
 * @param {Date} day1
 * @param {Date} day2
 * @return {Number}
 */
export function rangeDay(day1, day2) {
  if (!day1 || !day2) return 0
  const res = []
  const dayTime = 24 * 60 * 60 * 1000
  const startTime = new Date(day1).getTime()
  const range = new Date(day2).getTime() - startTime
  let total = 0
  while (total <= range) {
    res.push(new Date(startTime + total).toLocaleDateString().replace(/\//g, '-'))
    total += dayTime
  }
  return res
}

/**
 * @description 毫秒格式化
 */
export function secondFomart(msTime = 0) {
  if (!msTime) return '-'
  if (msTime < 60000) return '不足1min'
  const time = msTime / 1000
  let hour = Math.floor(time / 60 / 60)
  let minute = Math.floor(time / 60) % 60

  hour = hour > 0 ? `${hour}h` : ''
  minute = minute > 0 ? `${minute}min` : ''

  return `${hour}${minute}`
}

// 路径匹配：全等或正则匹配
export function isPathIncluded(path, paths = []) {
  return paths.some(p => {
    if (p instanceof RegExp) {
      return p.test(path)
    }
    return p === path
  })
}
